export const PAYMENT_METHODS = [
  {
    id: "Paymentez",
    label: "Paymentez",
    fields: [
      {
        id: "authCode",
        label: "Codigo de autorizacion",
      },
      {
        id: "authAmount",
        label: "Monto autorizado",
      },
      {
        id: "payMethod",
        label: "Tipo de metodo de pago",
      },
      {
        id: "authQuantity",
        label: "Cantidad autorizada",
      },
      {
        id: "cardNumber",
        label: "numero de tarjeta",
      },
    ],
  },
  {
    id: "Zumpago",
    label: "Zumpago",
    fields: [
      {
        id: "authCode",
        label: "Codigo de autorizacion",
      },
      {
        id: "authAmount",
        label: "Monto autorizado",
      },
      {
        id: "payMethod",
        label: "Tipo de metodo de pago",
      },
      {
        id: "authQuantity",
        label: "Cantidad autorizada",
      },
    ],
  },
];
